import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import { Factory } from '@mui/icons-material';
import OperatorHeader from '../ui-component/header/OperatorHeader';

// dashboard routing
const PanelOperator = Loadable(lazy(() => import('views/pages/panel/Panel')));
const EditReportRequestsPage = Loadable(lazy(() => import('views/pages/operator/EditReportRequestsPage')));
const EditDistributionList = Loadable(lazy(() => import('views/pages/operator/EditDistributionList')));

const TechnicSupportForm = Loadable(lazy(() => import('views/pages/operator/TechnicSupportsPage')));

// Support pages
const SupportIncidentsPage = Loadable(lazy(() => import('views/pages/support/SupportIncidentsPage')));
const IncidentDetailPage = Loadable(lazy(() => import('views/pages/support/IncidentDetailPage')));

// Production pages
const PieceRecordForm = Loadable(lazy(() => import('views/pages/operator/production/PieceRecordForm')));
const PieceRecordFunctionalForm = Loadable(lazy(() => import('views/pages/operator/production/PieceRecordFunctionalForm')));
const PieceRecordNonFunctionalForm = Loadable(lazy(() => import('views/pages/operator/production/PieceRecordNonFunctionalForm')));
const PieceDefectTypesForm = Loadable(lazy(() => import('views/pages/operator/production/PieceDefectTypesForm')));
const DefectDistributionForm = Loadable(lazy(() => import('views/pages/operator/production/DefectDistributionForm')));
const EditDistributionForm = Loadable(lazy(() => import('views/pages/operator/EditDistributionForm')));
const ProductionRecordsPage = Loadable(lazy(() => import('views/pages/operator/ProductionRecordsPage')));
const ProductionStatsPage = Loadable(lazy(() => import('views/pages/operator/ProductionStatsPage')));

const Profile = Loadable(lazy(() => import('views/pages/users/profile/Profile')));

//Extras
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <OperatorHeader />,
    children: [
        {
            path: '/',
            element: <PanelOperator />
        },
        {
            path: 'profile',
            element: <Profile />
        },
        {
            path: 'operator',
            children: [
                {
                    path: 'production',
                    children: [
                        {
                            path: 'piece-record',
                            children: [
                                {
                                    index: true,
                                    element: <PieceRecordForm />
                                },
                                {
                                    path: 'functional',
                                    element: <PieceRecordFunctionalForm />
                                },
                                {
                                    path: 'non-functional',
                                    element: <PieceRecordNonFunctionalForm />
                                },
                                {
                                    path: 'select-defects',
                                    element: <PieceDefectTypesForm />
                                },
                                {
                                    path: 'non-functional/distribution',
                                    element: <DefectDistributionForm />
                                }
                            ]
                        },
                        {
                            path: 'records',
                            element: <ProductionRecordsPage />
                        },
                        {
                            path: 'stats',
                            element: <ProductionStatsPage />
                        }
                    ]
                },
                {
                    path: 'edit-requests',
                    children: [
                        {
                            path: 'new',
                            element: <EditReportRequestsPage />
                        },
                        {
                            path: 'non-functional/distribution',
                            element: <EditDistributionForm />
                        },
                        {
                            path: 'detail',
                            element: <EditDistributionList />
                        }
                    ]
                },
                {
                    path: 'support-form',
                    element: <TechnicSupportForm />
                }
            ]
        },
        {
            path: '*',
            element: <PanelOperator />
        }
    ]
};

export default MainRoutes;
